/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentNotes from './treatment-notes';
import TreatmentNotesDetail from './treatment-notes-detail';
import TreatmentNotesUpdate from './treatment-notes-update';
import TreatmentNotesDeleteDialog from './treatment-notes-delete-dialog';

const TreatmentNotesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentNotes />} />
    <Route path="new" element={<TreatmentNotesUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentNotesDetail />} />
      <Route path="edit" element={<TreatmentNotesUpdate />} />
      <Route path="delete" element={<TreatmentNotesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentNotesRoutes;
